import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 px-4 sm:px-6 bg-white" data-id="element-79">
      <div className="text-center mb-6" data-id="element-80">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-2 uppercase leading-tight" data-id="element-81">
          YOUR INVESTMENT IS 100% PROTECTED
        </h2>
      </div>

      <div className="bg-brand-paper border-2 border-brand-gold p-6 sm:p-8 rounded-xl text-center shadow-lg max-w-2xl mx-auto relative overflow-hidden" data-id="element-82">
        <div className="absolute top-0 left-0 w-full h-2 bg-brand-gold" data-id="element-83" />

        <div className="w-20 h-20 mx-auto bg-brand-gold/10 rounded-full flex items-center justify-center mb-5 border border-brand-gold/30" data-id="element-84">
          <ShieldCheck className="w-10 h-10 text-brand-gold" data-id="element-85" />
        </div>
        <h3 className="text-xl sm:text-2xl font-heading font-black text-brand-navy mb-3 uppercase leading-tight" data-id="element-86">
          🛡️ 7-Day Total Guarantee
        </h3>
        <p className="text-base font-bold text-brand-ink mb-4 uppercase tracking-wide" data-id="element-87">
          Your money is 100% protected.
        </p>
        <p className="text-sm text-brand-ink/80 leading-relaxed mb-4" data-id="element-88">
          You have 7 full days to explore the entire system, review the
          programs, implement the workouts, and evaluate the results with your
          athletes.
        </p>
        <p className="text-sm text-brand-ink/80 leading-relaxed font-medium" data-id="element-89">
          If you're not completely satisfied for any reason, we'll refund 100%
          of your money.
          <br data-id="element-90" />
          <span className="text-brand-red font-bold" data-id="element-91">
            Zero risk. No questions asked.
          </span>
        </p>
      </div>
    </section>;
}